// Test hooks for the child components that need to be specifically addressed with a test id
export const TestHooks = {
	PurchaseSelectButton: 'purchase-select-button',
	IncludeDeletedCheckbox: 'include-deleted-checkbox',
	PdfIcon: 'pdf-icon',
	LoadingIcon: 'loading-icon',
	AllLotsCheckbox: 'all-lots-checkbox',
	SelectLotCheckbox: 'select-lot-checkbox',
	//	MyHookName: 'myHookIdentifier',
} as const;
/*
NOTE: The above hooks have been auto generated, all naming is a best guess approach.
Please review them, edit where necessary and delete this comment to indicate that the names are correct.
*/
